import { jsonApiFetch } from "./endpoint";

type Response = {};

function action(nip: string) {
  return jsonApiFetch<Response>("/nip", `{"nip":"${nip}"}`);
}

export { action as nip, Response as NipResponse };
